import { fetcher } from "helpers/fetcher";

import { TGetEODReportDetailsReq, TGetEODReportDetailsRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEODReportDetails = async (payload: TGetEODReportDetailsReq) => {
  return await fetcher<TGetEODReportDetailsRes, any>(
    ENDPOINT.MANAGEMENT.GET_EOD_REPORT_DETAILS,
    {
      headers: {
        [API_HEADER.VERSION]:
          ENDPOINT.MANAGEMENT.GET_EOD_REPORT_DETAILS.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: {
        date: payload.date,
        idTicket: payload.idTicket,
      },
    }
  );
};

export const queryGetEODReportDetails = async (
  payload: TGetEODReportDetailsReq
) => {
  return (await getEODReportDetails(payload)).data;
};

queryGetEODReportDetails._key = (payload: TGetEODReportDetailsReq) => [
  ENDPOINT.MANAGEMENT.GET_EOD_REPORT_DETAILS.url,
  payload,
];
